import {
  mediaDevices,
  RTCIceCandidate,
  RTCPeerConnection,
  RTCSessionDescription,
} from "react-native-webrtc";

class WebRTCService {
  constructor() {
    // @ts-ignore
    this.peerConnections = new Map(); // Map of peerId -> RTCPeerConnection
    // @ts-ignore
    this.localStream = null;
    // @ts-ignore
    this.isMuted = true; // Start muted by default
    // @ts-ignore
    this.remoteStreams = new Map(); // Map of peerId -> MediaStream for playback
    // @ts-ignore
    this.onRemoteStreamAdded = null; // Callback for when remote stream arrives
  }

  // Configuration for STUN servers
  // getConfiguration() {
  //   return {
  //     iceServers: [
  //       { urls: 'stun:stun.l.google.com:19302' },
  //       { urls: 'stun:stun1.l.google.com:19302' },
  //     ]
  //   };
  // }
  getConfiguration() {
    return {
      iceServers: [
        // { urls: 'stun:stun.l.google.com:19302' },
        // { urls: 'stun:stun1.l.google.com:19302' },
        {
          urls: "turn:161.35.231.67:3478",
          username: "Nsl",
          credential: "scape@123",
        },
      ],
      iceTransportPolicy: 'relay'
    };
  }

  // Get local audio stream (with permission prompt)
  async getLocalStream() {
    try {
      console.log("Requesting local audio stream...");
      const stream = await mediaDevices.getUserMedia({
        audio: {
    // @ts-ignore
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        video: false,
      });
    // @ts-ignore
      this.localStream = stream;

      // Start muted
    // @ts-ignore
      this.localStream.getAudioTracks().forEach((track) => {
        track.enabled = false;
      });

      console.log("Local stream acquired:", stream.id);
      return stream;
    } catch (error) {
      console.error("Error getting local stream:", error);
      throw error;
    }
  }

  // Create peer connection
    // @ts-ignore
  createPeerConnection(peerId, onRemoteStream) {
    //@ts-ignore
    const pc = new RTCPeerConnection(this.getConfiguration());
    console.log(`Creating peer connection for ${peerId}`);

    // Add local stream tracks
    // @ts-ignore
    if (this.localStream) {
    // @ts-ignore
      this.localStream.getTracks().forEach((track) => {
    // @ts-ignore
        pc.addTrack(track, this.localStream);
        console.log(`Added track to PC: ${track.kind}`);
      });
    }

    // Handle remote stream (notify immediately)
    // @ts-ignore
    pc.ontrack = (event) => {
      if (event.streams && event.streams[0]) {
        console.log(
          `Received remote stream from ${peerId}: ${event.streams[0].id}`
        );
    // @ts-ignore
        this.remoteStreams.set(peerId, event.streams[0]);
        onRemoteStream(peerId, event.streams[0]); // Existing callback
    // @ts-ignore
        if (this.onRemoteStreamAdded) {
    // @ts-ignore
          this.onRemoteStreamAdded(peerId, event.streams[0]); // Immediate notify
        }
      }
    };

    // Handle ICE candidates
    // @ts-ignore
    pc.onicecandidate = (event) => {
      if (event.candidate) {
        console.log(`ICE candidate for ${peerId}:`, event.candidate);
    // @ts-ignore
        this.onIceCandidate && this.onIceCandidate(peerId, event.candidate);
      }
    };

    // Handle connection state
    // @ts-ignore
    pc.oniceconnectionstatechange = () => {
      console.log(`ICE connection state (${peerId}): ${pc.iceConnectionState}`);
      if (
        pc.iceConnectionState === "failed" ||
        pc.iceConnectionState === "disconnected"
      ) {
        console.warn(
          `ICE connection failed for ${peerId}. Attempting reconnection...`
        );
      }
    };
    // @ts-ignore
    pc.onconnectionstatechange = () => {
      console.log(`Connection state (${peerId}): ${pc.connectionState}`);
    };
    // @ts-ignore
    this.peerConnections.set(peerId, pc);
    return pc;
  }

  // Create and send offer
    // @ts-ignore
  async createOffer(peerId) {
    // @ts-ignore
    const pc = this.peerConnections.get(peerId);
    if (!pc) return null;
    try {
      console.log(`Creating offer for ${peerId}`);
      const offer = await pc.createOffer({
        offerToReceiveAudio: true,
        offerToReceiveVideo: false,
      });
      await pc.setLocalDescription(offer);
      console.log(`Offer created for ${peerId}:`, offer.type);
      return offer;
    } catch (error) {
      console.error("Error creating offer:", error);
      return null;
    }
  }

  // Handle received offer
    // @ts-ignore
  async handleOffer(peerId, offer, onRemoteStream) {
    // @ts-ignore
    let pc = this.peerConnections.get(peerId);
    if (!pc) {
      pc = this.createPeerConnection(peerId, onRemoteStream);
    }
    try {
      console.log(`Handling offer from ${peerId}:`, offer.type);
      await pc.setRemoteDescription(new RTCSessionDescription(offer));
      const answer = await pc.createAnswer({
        offerToReceiveAudio: true,
        offerToReceiveVideo: false,
      });
      await pc.setLocalDescription(answer);
      console.log(`Answer created for ${peerId}:`, answer.type);
      return answer;
    } catch (error) {
      console.error("Error handling offer:", error);
      return null;
    }
  }

  // Handle received answer
    // @ts-ignore
  async handleAnswer(peerId, answer) {
    // @ts-ignore
    const pc = this.peerConnections.get(peerId);
    if (!pc) return;
    try {
      console.log(`Handling answer from ${peerId}:`, answer.type);
      await pc.setRemoteDescription(new RTCSessionDescription(answer));
    } catch (error) {
      console.error("Error handling answer:", error);
    }
  }

  // Handle ICE candidate
    // @ts-ignore
  async handleICECandidate(peerId, candidate) {
    // @ts-ignore
    const pc = this.peerConnections.get(peerId);
    if (!pc) return;
    try {
      console.log(`Adding ICE candidate for ${peerId}`);
      await pc.addIceCandidate(new RTCIceCandidate(candidate));
    } catch (error) {
      console.error("Error adding ICE candidate:", error);
    }
  }

  // Toggle mute
  toggleMute() {
    // @ts-ignore
    if (!this.localStream) return false;
    // @ts-ignore
    this.isMuted = !this.isMuted;
    // @ts-ignore
    this.localStream.getAudioTracks().forEach((track) => {
    // @ts-ignore
      track.enabled = !this.isMuted;
    });
    // @ts-ignore
    console.log(`Local mute toggled: ${this.isMuted}`);
    // @ts-ignore
    return this.isMuted;
  }

  // Set mute state
    // @ts-ignore
  setMuted(muted) {
    // @ts-ignore
    if (!this.localStream) return;
    // @ts-ignore
    this.isMuted = muted;
    // @ts-ignore
    this.localStream.getAudioTracks().forEach((track) => {
    // @ts-ignore
      track.enabled = !this.isMuted;
    });
  }

  // Close specific peer connection
    // @ts-ignore
  closePeerConnection(peerId) {
    // @ts-ignore
    const pc = this.peerConnections.get(peerId);
    if (pc) {
      pc.close();
    // @ts-ignore
      this.peerConnections.delete(peerId);
    // @ts-ignore
      this.remoteStreams.delete(peerId); // Clean up stream
      console.log(`Closed peer connection for ${peerId}`);
    }
  }

  // Cleanup all connections
  cleanup() {
    // @ts-ignore
    this.peerConnections.forEach((pc, peerId) => {
      pc.close();
      console.log(`Cleaned up peer connection for ${peerId}`);
    });
    // @ts-ignore
    this.peerConnections.clear();
    // @ts-ignore
    this.remoteStreams.clear();
    // @ts-ignore
    if (this.localStream) {
    // @ts-ignore
      this.localStream.getTracks().forEach((track) => track.stop());
    // @ts-ignore
      this.localStream = null;
    }
  }

  // Set ICE candidate callback
    // @ts-ignore
  setOnIceCandidate(callback) {
    // @ts-ignore
    this.onIceCandidate = callback;
  }

  // Set callback for remote stream addition
    // @ts-ignore
  setOnRemoteStreamAdded(callback) {
    // @ts-ignore
    this.onRemoteStreamAdded = callback;
  }

  // Get remote streams (for VoiceComponent)
  getRemoteStreams() {
    // @ts-ignore
    return new Map(this.remoteStreams);
  }
}

export default new WebRTCService();
